import CategoriesView from "../view/categories.js";

import CategoriesModel from "../model/categories.js";

import {
  defaultCategoriesModelData,
  ActionType
} from "../const.js";

import {
  ActionType as FavoriteDataActionType
} from "../../favorite-data/const.js";

export default class Categories {
  constructor(element) {
    this._element = element;

    this._view = null;
    this._model = null;

    this._handleCategoriesSelectChange = this._handleCategoriesSelectChange.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this._view = new CategoriesView(this._element);
    this._view.setChangeHandler(this._handleCategoriesSelectChange);

    const activeCategoryId = this._view.getActiveCategoryId();

    this._model = new CategoriesModel(Object.assign(
        {},
        defaultCategoriesModelData,
        {
          activeCategoryId
        }
    ));
    this._model.addObserver(this._handleChangeData);
  }

  getActiveCategoryId() {
    return this._model.getData().activeCategoryId;
  }

  _processChangeCategory() {
    if (window.FavoriteData) {
      window.FavoriteData.changeData(Object.assign(
          {},
          window.FavoriteData.getData()
      ), FavoriteDataActionType.CHANGE_CATEGORY);
    }
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.CHANGE_CATEGORY:
        this._processChangeCategory();
        break;
    }
  }

  _handleCategoriesSelectChange(activeCategoryId) {
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          activeCategoryId
        }
    ), ActionType.CHANGE_CATEGORY);
  }
}
